import { createSelector } from '@reduxjs/toolkit';
import { selectIsSuburbanListing } from 'shared/selectors/jsonQuery';
import { IConfig } from '@cian/config/shared';

export const selectWithNeighborsByDefaultOff = (config: IConfig) =>
  createSelector(
    selectIsSuburbanListing,
    isSuburbanListing =>
      isSuburbanListing && !!config.get<boolean>('Countryside.SearchWithNeighborsByDefaultOff.Enabled'),
  );
